import React, { MouseEventHandler } from 'react';
import { fromJS } from 'immutable';
import useAppContext from 'flow/hooks/useAppContext';
import { Refer } from 'flow/types/Pbx';
import { TypedMap } from 'flow/types/TypedMap';
import { extractStatusText, getActiveUntil } from 'flow/utils';
import PbxListItem from './PbxListItem';
import { RowMarking } from './BaseListItem';

interface Props {
    item: TypedMap<Refer>;
    onClick: MouseEventHandler;
    marking?: RowMarking;
    enableCallButton?: boolean;
}

const ListItemPbxIvr = ({
    item,
    onClick,
    marking,
    enableCallButton,
}: Props) => {
    const { i18next } = useAppContext();

    return (
        <PbxListItem
            onClick={onClick}
            marking={marking}
            type="ivr"
            title={item.get('description')}
            description={
                item.get('activeProfile') &&
                `${extractStatusText(
                    item.get('activeProfile'),
                    i18next,
                )} ${getActiveUntil(item.get('activeProfile'), i18next)}`
            }
            phoneNumber={
                item.getIn(['activeProfile', 'available']) &&
                item.getIn(['number', 'number']) &&
                enableCallButton &&
                item.getIn(['number', 'number'])
            }
            additionalCallInfo={fromJS({
                description: item.get('description'),
                key: item.get('key'),
            })}
        />
    );
};

export default ListItemPbxIvr;
